import ERROR_CODES from './errorCodes'

function parseGithubApiV3Response(response){
  return response.json()
  .then(json => {
    if ((response.status + '').startsWith('2') == false && json['message']){
      var error = new Error(json['message'])
      error.code = ERROR_CODES.GITHUB_API_V3_ERROR
      error.uri = json['documentation_url']
      throw error
    }
    return json
  })
}

export default parseGithubApiV3Response


// WEBPACK FOOTER //
// ./src/lib/parseGithubApiV3Response.js